"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authConfiguration = void 0;
exports.authConfiguration = [
    {
        cognitoConfigIdentifier: 'default',
        cognitoConfig: {
            cognitoUserPoolId: 'ap-southeast-2_vUVRlSMWa',
            cognitoUserPoolWebClientId: '1g1a80gfo3ovuq75c8fqjrg3ma',
            cognitoRegion: 'ap-southeast-2',
        },
    },
    {
        cognitoConfigIdentifier: 'CDFpay',
        cognitoConfig: {
            cognitoUserPoolId: 'ap-southeast-2_3z7myKjyZ',
            cognitoUserPoolWebClientId: '1upr9o68kod293tqjva3gp79vm',
            cognitoRegion: 'ap-southeast-2',
        },
    },
];
//# sourceMappingURL=AuthConfig.js.map